import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { initialize, submit } from 'redux-form';
import * as ModalActions from '../../../redux/actions/modal.actions.js';
import * as IntercomActions from '../../../redux/actions/intercom.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import MDButton from '../../MDButton/MDButton.jsx';
import FormCardContainer from '../../forms/Elements/FormCardContainer.jsx';
import ExtensionGroupForm from '../../forms/Extension/ExtensionGroupForm.jsx';
import BasicModal from '../../Modals/BasicModal.jsx';
import { BLUE, GREEN, RED } from '../../../_config/consts';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import FormFlatContainer from '../../forms/Elements/FormFlatContainer.jsx';

@connect((state) => ({ 
  extensionGroups: state.intercom.extensionGroups.content,
}))
class VirtualIntercomSettingsOperationalSection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedGroup: null,
      hoveredRow: null,
      hoveredEdit: null,
      hoveredDelete: null
    };
  }

  async componentWillMount() {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(IntercomActions.fetchExtensionGroups());
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch(error) {
      console.log(error)
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  showNewExtensionGroupModal() {
    const { dispatch } = this.props;
    dispatch(initialize('ExtensionGroupForm', {}));
    this.newExtensionGroupModal.open();
  }

  showEditExtensionGroupModal(group) {
    const { dispatch } = this.props;
    this.setState({ selectedGroup: group });
    dispatch(initialize('ExtensionGroupForm', { name: group.name }));
    this.editExtensionGroupModal.open();
  }

  showDeleteExtensionGroupModal(group) {
    const { dispatch } = this.props;
    this.setState({ selectedGroup: group });
    dispatch(ModalActions.showModal({
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="deleteExtensionGroupMessage" />,
        onConfirmText: <Entity entity="confirm" />,
        onConfirm: () => this.deleteExtensionGroup(group),
        onCancelText: <Entity entity="cancel" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      }
    }));
  }

  async createExtensionGroup(values) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(IntercomActions.createExtensionGroup(values));
      await dispatch(IntercomActions.fetchExtensionGroups());
      this.newExtensionGroupModal.close();
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  async editExtensionGroup(values) {
    const { dispatch } = this.props;
    const { selectedGroup } = this.state;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(IntercomActions.editExtensionGroup(selectedGroup.id, values));
      await dispatch(IntercomActions.fetchExtensionGroups());
      this.editExtensionGroupModal.close();
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  async deleteExtensionGroup(group) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(IntercomActions.deleteExtensionGroup(group.id));
      await dispatch(IntercomActions.fetchExtensionGroups());
      dispatch(ModalActions.hideModal());
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="extensionGroupDeleteSuccess"/></h6>),
        },
      }));
    } catch (error) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="extensionGroupDeleteError" /></h6>),
        },
      }));
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  render() {
    const { dispatch, extensionGroups } = this.props;
    return (
      <div style={{ paddingLeft: 20, paddingRight: 25 }}>
        <FormFlatContainer title="extensionGroupsTitle" containerStyle={{ marginRight: 10, marginTop: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 0 }}>
            <MDButton
              title={<Entity entity="createExtensionGroup" />}
              onClick={() => this.showNewExtensionGroupModal()}
              containerStyle={{ marginLeft: 0 }}
            />
          </div>

          <div>
            {extensionGroups.map(group => (
              <div 
                key={group.id} 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  padding: '15px 20px',
                  marginBottom: 12,
                  backgroundColor: this.state.hoveredRow === group.id ? '#f0f2f5' : '#f8f9fa',
                  borderRadius: 8,
                  boxShadow: this.state.hoveredRow === group.id 
                    ? '0 2px 5px rgba(0,0,0,0.15)' 
                    : '0 1px 3px rgba(0,0,0,0.1)',
                  transition: 'all 0.2s ease',
                  cursor: 'default'
                }}
                onMouseEnter={() => this.setState({ hoveredRow: group.id })}
                onMouseLeave={() => this.setState({ hoveredRow: null })}
              >
                <div style={{ fontSize: 16, fontWeight: 500, color: '#2c3e50' }}>{group.name}</div>
                <div style={{ display: 'flex', gap: 16 }}>
                  <div 
                    style={{ 
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      padding: '8px',
                      borderRadius: '50%',
                      backgroundColor: this.state.hoveredEdit === group.id ? '#ddd' : 'transparent',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onClick={() => this.showEditExtensionGroupModal(group)}
                    onMouseEnter={() => this.setState({ hoveredEdit: group.id })}
                    onMouseLeave={() => this.setState({ hoveredEdit: null })}
                  >
                    <EditIcon style={{ color: BLUE, fontSize: 22 }} />
                  </div>
                  <div 
                    style={{ 
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      padding: '8px',
                      borderRadius: '50%',
                      backgroundColor: this.state.hoveredDelete === group.id ? '#ddd' : 'transparent',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onClick={() => this.showDeleteExtensionGroupModal(group)}
                    onMouseEnter={() => this.setState({ hoveredDelete: group.id })}
                    onMouseLeave={() => this.setState({ hoveredDelete: null })}
                  >
                    <DeleteIcon style={{ color: RED, fontSize: 22 }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </FormFlatContainer>

        <BasicModal
          ref={(m) => { this.newExtensionGroupModal = m; }}
          title={<Entity entity="newExtensionGroup" />}
          body={
            <div>
              <ExtensionGroupForm
                onSubmit={values => this.createExtensionGroup(values)}
              />
              <MDButton
                containerStyle={{ marginTop: 30 }}
                title={<Entity entity="createExtensionGroup" />}
                onClick={() => dispatch(submit('ExtensionGroupForm'))}
              />
            </div>
          }
        />

        <BasicModal
          ref={(m) => { this.editExtensionGroupModal = m; }}
          title={<Entity entity="editExtensionGroup" />}
          body={
            <div>
              <ExtensionGroupForm
                onSubmit={values => this.editExtensionGroup(values)}
              />
              <MDButton
                containerStyle={{ marginTop: 30 }}
                title={<Entity entity="saveExtensionGroup" />}
                onClick={() => dispatch(submit('ExtensionGroupForm'))}
              />
            </div>
          }
        />
      </div>
    );
  }
}

export default VirtualIntercomSettingsOperationalSection;
